// extracted by mini-css-extract-plugin
module.exports = {"section":"styles__section___1OaYt","container":"styles__container___3fZvb","title":"styles__title___gZL11","members-container":"styles__members-container___37WMB"};